import { PRIMARY } from '../enums/constants';
/**
 *
 *
 */
export const defaultConfig = {
    distribution: [],
    classPrefix: 'muze',
    isDistributionEqual: true,
    unitMeasures: {
        height: 100,
        width: 100,
        border: 1
    },
    isTransposed: false,
    facet: PRIMARY,
    extraCellLengths: []
};
